<template>
  <div class="ui-stepper">
    <div class="mob">
      <p class="mob__top">
        <span class="highlight">Korak {{ current + 1 }}</span>
        / {{ steps.length }} - {{ steps[current] }}
      </p>
      <div class="mob__progress-wrapper">
        <div class="mob__progress">
          <div class="mob__progress-done" ref="$progress"></div>
        </div>
      </div>
    </div>

    <div class="desktop" ref="$d-stepper">
      <div
          class="step"
          v-for="(step, index) in steps"
          v-bind:key="index"
          :class="{
          'step-current': current === index,
          'step-disabled': current < index,
          'step-done': current > index,
        }"
          :ref="'step_' + index"
      >
        <div class="step__label">{{ step }}</div>
        <div class="step-bg"></div>
        <span class="step__text">{{ index + 1 }}</span>
        <div class="step-divider" v-if="index !== steps.length - 1"></div>
        <div
            class="step-divider-done"
            v-if="index !== steps.length - 1"
            :ref="'divider-done_' + index"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      lineWidth: 0,
      stepMargin: 13,
    };
  },
  props: {
    steps: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value) && value.length >= 2,
    },
    current: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
  },
  methods: {
    initUI() {
      this.setProgressUI(this.current);
      this.setLinesUi();
    },
    setProgressUI(step) {
      if (this.$refs["$progress"] && this.$refs["$progress"].clientWidth) {
        const percentage = ((step + 1) / this.steps.length) * 100;
        this.$refs["$progress"].style.width = `${percentage}%`;
      }
    },
    setLinesUi() {
      if (this.$refs["$d-stepper"] && this.$refs["$d-stepper"].clientWidth) {
        const width = this.$refs["$d-stepper"].clientWidth;
        const stepsWidth = this.steps.length * 30;

        const availableWidth =
            width -
            stepsWidth -
            (this.steps.length - 1) * this.stepMargin * 2 - 10;

        this.lineWidth = availableWidth / (this.steps.length - 1);

        for (const sd of this.$el.querySelectorAll(".step-divider")) {
          sd.style.width = `${this.lineWidth}px`;
          sd.style.right = `-${this.lineWidth + this.stepMargin}px`;
        }

        for (let i = 0; i < this.current; i++) {
          const doneLine = this.$refs["divider-done_" + i];

          if (doneLine) {
            doneLine[0].style.width = this.lineWidth;
          }
        }

        const $steps = this.$el.querySelectorAll(".step");

        for (let i = 0; i < $steps.length; i++) {
          const sd = $steps[i];

          if (i == 0) {
            sd.style.marginLeft = "0px";
            sd.style.marginRight = `${this.lineWidth + this.stepMargin}px`;
          } else if (i === this.steps.length - 1) {
            sd.style.marginLeft = `${this.stepMargin}px`;
            sd.style.marginRight = "0px";
          } else {
            sd.style.marginLeft = `${this.stepMargin}px`;
            sd.style.marginRight = `${this.lineWidth + this.stepMargin}px`;
          }
        }

        const $labels = this.$el.querySelectorAll(".step__label");
        const labelWidth = width / this.steps.length;

        for (const label of $labels) {
          label.style.width = labelWidth + "px";
          label.style.left = (labelWidth / 2) * -1 + 15.5 + "px";
          label.style.top = (label.offsetHeight + 5) * -1 + "px";
        }

        this.stepLeftIn(0);
      }
    },
    onNextStepPerformed() {
      const afterStepDoneLine =
          this.$refs["divider-done_" + (this.current - 1)];

      if (afterStepDoneLine) {
        afterStepDoneLine[0].style.width = this.lineWidth + "px";
      }

      this.emitStepPeformed();

      this.stepRightOut(this.current - 1);
      setTimeout(this.stepLeftIn.bind(this, this.current), 400);
    },
    onPrevStepPerformed() {
      const afterStepDoneLine = this.$refs["divider-done_" + this.current];

      if (afterStepDoneLine) {
        afterStepDoneLine[0].style.width = "0px";
      }

      this.emitStepPeformed();

      this.stepLeftOut(this.current + 1);
      setTimeout(this.stepRightIn.bind(this, this.current), 400);
    },
    stepLeftIn(stepIndex) {
      const $step = this.$refs["step_" + stepIndex][0];

      if (!$step) return;

      const $stepBG = $step.querySelector(".step-bg");
      $stepBG.style.right = "initial";
      $stepBG.style.left = 0;
      $stepBG.style.width = "100%";
      $stepBG.style.height = "100%";
      $stepBG.style.top = "0";
    },
    stepLeftOut(stepIndex) {
      const $step = this.$refs["step_" + stepIndex][0];
      const $stepBG = $step.querySelector(".step-bg");
      $stepBG.style.right = "initial";
      $stepBG.style.left = 0;
      $stepBG.style.width = "0";
      $stepBG.style.height = "10%";
      $stepBG.style.top = "50%";
    },
    stepRightIn(stepIndex) {
      const $step = this.$refs["step_" + stepIndex][0];
      const $stepBG = $step.querySelector(".step-bg");
      $stepBG.style.left = "initial";
      $stepBG.style.right = 0;
      $stepBG.style.width = "100%";
      $stepBG.style.height = "100%";
      $stepBG.style.top = "0";
    },
    stepRightOut(stepIndex) {
      const $step = this.$refs["step_" + stepIndex][0];
      const $stepBG = $step.querySelector(".step-bg");
      $stepBG.style.left = "initial";
      $stepBG.style.right = 0;
      $stepBG.style.width = "0";
      $stepBG.style.height = "10%";
      $stepBG.style.top = "50%";
    },
    emitStepPeformed() {
      this.$emit("step-change-performed");
    },
  },
  watch: {
    current(newValue, oldValue) {
      this.setProgressUI(newValue);

      if (newValue > oldValue) {
        this.onNextStepPerformed();
      } else {
        this, this.onPrevStepPerformed();
      }
    },
  },
  mounted() {
    this.initUI();
    window.addEventListener("resize", this.initUI.bind(this));
  },
  destroyed() {
    window.removeEventListener("resize", this.initUI.bind(this));
  },
};
</script>

<style scoped>
@media (min-width: 280px) {
  .desktop {
    display: none;
  }

  .highlight {
    color: rgb(24, 156, 146);
    font-weight: 700;
  }

  .ui-stepper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ui-stepper .mob {
    width: calc(91.5% + 10px);
  }

  .ui-stepper .mob .mob__top {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #4c4c4c;
    padding-left: 5px;
  }

  .ui-stepper .mob .mob__progress-wrapper {
    border-radius: 10px;
    background-color: white;

    box-shadow: 0px 30px 40px 0.25px rgba(0, 0, 0, 0.15);

    border: 1px solid transparent;
  }

  .ui-stepper .mob .mob__progress {
    margin: 5px;
    height: 8px;
    border-radius: 10px;
    background-color: #f2f2f2;
  }

  .ui-stepper .mob .mob__progress .mob__progress-done {
    height: 8px;
    background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%);

    border-radius: 10px;
    transition: width 0.3s ease-in-out;
  }
}

@media (min-width: 768px) {
  .ui-stepper {
    justify-content: flex-start;
  }
}

@media (min-width: 1135px) {
  .ui-stepper .mob {
    display: none;
  }

  .ui-stepper {
    padding-left: 7.5px;
  }

  .ui-stepper .desktop {
    display: block;
    height: 168px;
    padding-top: 84px;

    width: 100%;
    /*width: calc(100% - 50px);*/
  }

  .ui-stepper .desktop .step {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 30px;

    text-align: center;
    line-height: 30px;

    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    border-radius: 50%;

    transition: all 0.3s ease-in-out;
  }

  .ui-stepper .desktop .step .step__text {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .ui-stepper .desktop .step .step-bg {
    position: absolute;
    top: 50%;
    width: 0;
    height: 10%;

    background-color: #1ea89c;
    border-radius: 50%;

    transition: all 0.3s ease;
  }

  .ui-stepper .desktop .step-done .step-bg {
    background-color: white;
  }

  .step__label {
    position: absolute;
    width: 0;
    overflow: hidden;

    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 25px;

    color: #4c4c4c;
    display: inline-block;
    vertical-align: bottom;
    word-break: break-all;
    text-align: center;
    height: 25px;

    transition: all 0.3s ease-in-out;
  }

  .step-done {
    border: 1px solid #1ea89c;
    background: white !important;
    color: #1ea89c;
  }

  .step-current {
    border: 1px solid #1ea89c;
    color: white;
  }

  .step-disabled {
    background-color: white;
    border: 1px solid #dddddd;
    color: #dddddd;
  }

  .ui-stepper .desktop .step .step-divider {
    position: absolute;
    top: 50%;

    height: 1px;
    background-color: #dddddd;
  }

  .ui-stepper .desktop .step .step-divider-done {
    position: absolute;
    top: 50%;
    left: 43px;

    height: 1px;
    width: 0px;
    background-color: #006c68;

    transition: all 0.3s ease-in-out;
  }
}
</style>
